import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FormLlmInterfacesQueryVariables = Types.Exact<{
  formId: Types.Scalars['ID']['input'];
}>;


export type FormLlmInterfacesQuery = { __typename: 'PharosQuery', formLlmInterface_List: { __typename: 'FormLlmInterfaceTypeListBase', objects: Array<{ __typename: 'FormLlmInterfaceType', id: string, llmInterface: { __typename: 'LlmInterfaceType', id: string } }> } | null };


export const FormLlmInterfacesDocument = gql`
    query formLlmInterfaces($formId: ID!) {
  formLlmInterface_List(formId: $formId) {
    objects {
      id
      llmInterface {
        id
      }
    }
  }
}
    `;

/**
 * __useFormLlmInterfacesQuery__
 *
 * To run a query within a React component, call `useFormLlmInterfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormLlmInterfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormLlmInterfacesQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormLlmInterfacesQuery(baseOptions: Apollo.QueryHookOptions<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables> & ({ variables: FormLlmInterfacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables>(FormLlmInterfacesDocument, options);
      }
export function useFormLlmInterfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables>(FormLlmInterfacesDocument, options);
        }
export function useFormLlmInterfacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables>(FormLlmInterfacesDocument, options);
        }
export type FormLlmInterfacesQueryHookResult = ReturnType<typeof useFormLlmInterfacesQuery>;
export type FormLlmInterfacesLazyQueryHookResult = ReturnType<typeof useFormLlmInterfacesLazyQuery>;
export type FormLlmInterfacesSuspenseQueryHookResult = ReturnType<typeof useFormLlmInterfacesSuspenseQuery>;
export type FormLlmInterfacesQueryResult = Apollo.QueryResult<FormLlmInterfacesQuery, FormLlmInterfacesQueryVariables>;